import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Constants } from "../constants/constants";
import { HttpClient } from "../authentication/httpClient";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

@Injectable()
export class GlCodeService {

	constructor(private http: HttpClient) { }

	getAllGlCodes(): Observable<Array<IGLCodeModel>> {
		return this.http.get(`${Constants.restUrl}GlCode/GetAllGlCodes`).map((res: Response) => res.json()).catch(this.handleError);
	}

	getGlCode(id: number): Observable<IGLCodeModel> {
		return this.http.get(`${Constants.restUrl}GlCode/GetGlCode/${id}`).map((res: Response) => res.json()).catch(this.handleError);
	}

	updateGlCode(glCode: IGLCodeModel) {
		return this.http.put(`${Constants.restUrl}GlCode/UpdateGlCode`, glCode).map((res: Response) => res.json()).catch(this.handleError);
	}

	addGlCode(glCode: IGLCodeModel) {
		return this.http.post(`${Constants.restUrl}GlCode/AddGlCode`, glCode).map((res: Response) => res.json()).catch(this.handleError);
	}

	private handleError(error: any): Observable<any> {
		console.error("An error occurred", error);
		return Observable.throw(error.message || error);
	}
}